// src/extenders/product-button.js
var ProductButton = class extends HTMLElement {
  constructor() {
    super();
    const ProductButtonElement = this;
    const ProductVariationLinks = ProductButtonElement.querySelectorAll(".product-variation-link");
    const link = ProductButtonElement.querySelectorAll(".link");
    const price = ProductButtonElement.querySelector(".price");
    const title = ProductButtonElement.querySelector(".title");
    const color = ProductButtonElement.querySelector(".color");
    const removeActiveClass = (ProductVariationLinks2, activeDiv) => {
      ProductVariationLinks2.forEach((productVariationLink) => {
        const div = productVariationLink.querySelector("div");
        if (div !== activeDiv && div.classList.contains("js-active")) {
          div.classList.remove("js-active");
        }
      });
    };
    ProductVariationLinks.forEach((productVariationLink) => {
      productVariationLink.addEventListener(
        "mouseenter",
        () => {
          const mainImage = productVariationLink.getAttribute("data-image");
          const hoverImage = productVariationLink.getAttribute("data-hover-image");
          const placeholderImage = productVariationLink.getAttribute("data-placeholder-image");
          const activeUrl = productVariationLink.getAttribute("data-url");
          const activePrice = productVariationLink.getAttribute("data-price");
          const activeTitle = productVariationLink.getAttribute("data-title");
          const activeColor = productVariationLink.getAttribute("data-color");
          const mainImageElement = ProductButtonElement.querySelector(".featured-image img");
          const hoverImageElement = ProductButtonElement.querySelector(".hover-image img");
          const placeholderImageElement = ProductButtonElement.querySelector(".placeholder-image img");
          const activeDiv = productVariationLink.querySelector("div");
          mainImageElement == null ? void 0 : mainImageElement.removeAttribute("srcset");
          hoverImageElement == null ? void 0 : hoverImageElement.removeAttribute("srcset");
          if (!mainImage.includes("invalid")) {
            mainImageElement == null ? void 0 : mainImageElement.setAttribute("src", mainImage);
            hoverImageElement == null ? void 0 : hoverImageElement.setAttribute("src", hoverImage);
          } else {
            mainImageElement == null ? void 0 : mainImageElement.setAttribute("srcset", placeholderImage);
            hoverImageElement == null ? void 0 : hoverImageElement.setAttribute("srcset", placeholderImage);
            placeholderImageElement == null ? void 0 : placeholderImageElement.setAttribute("srcset", placeholderImage);
          }
          activeDiv.classList.add("js-active");
          link.forEach((a) => {
            a.setAttribute("href", activeUrl);
          });
          price.innerHTML = activePrice;
          title.innerHTML = activeTitle;
          color.innerHTML = activeColor;
          removeActiveClass(ProductVariationLinks, activeDiv);
        }
      );
    });
  }
};
if (customElements.get("product-button") === void 0) {
  customElements.define("product-button", ProductButton);
}
